import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
let ModalWrap = class ModalWrap extends Vue {
    created() {
        console.log('rrrrr', this);
    }
    mounted() {
        console.log('rrrrr222', this.$slots.more);
    }
    moreClick() {
        this.$emit('moreBtnClick');
    }
};
tslib_1.__decorate([
    Prop()
], ModalWrap.prototype, "classes", void 0);
ModalWrap = tslib_1.__decorate([
    Component({})
], ModalWrap);
export default ModalWrap;
